/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Macos_S3Inputs */

const en_fc_dl_macos_s3 = /** @type {(inputs: Fc_Dl_Macos_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch it from Applications. If macOS says it cannot verify the app, open System Settings, Privacy & Security, scroll down and click Open Anyway.`)
};

/**
* | output |
* | --- |
* | "Launch it from Applications. If macOS says it cannot verify the app, open System Settings, Privacy & Security, scroll down and click Open Anyway." |
*
* @param {Fc_Dl_Macos_S3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_macos_s3 = /** @type {((inputs?: Fc_Dl_Macos_S3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Macos_S3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_macos_s3(inputs)
});
export { fc_dl_macos_s3 as "fc.dl.macos.s3" }